import { render, staticRenderFns } from "./ImageSlider.vue?vue&type=template&id=c8986614&scoped=true&"
import script from "./ImageSlider.vue?vue&type=script&lang=js&"
export * from "./ImageSlider.vue?vue&type=script&lang=js&"
import style0 from "./ImageSlider.vue?vue&type=style&index=0&id=c8986614&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8986614",
  null
  
)

export default component.exports